"use strict";

var _Column, _Column2, _Column3;
import { CDN } from '@autoguru/global-configs';
import { HeaderLayout } from '@autoguru/header-layout';
import { Box, Column, Columns } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { GlobalSupplierSelect, SupplierRequiredBoundary } from '@autoguru/supplier-provider';
import { SupportHeader } from '@autoguru/support-header';
import { GlobalNotification } from '../components/GlobalNotification';
import { GlobalSearch } from '../components/GlobalSearch';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AppHeaderDesktop = () => /*#__PURE__*/_jsx(HeaderLayout, {
  safePaddings: true,
  children: /*#__PURE__*/_jsxs(Columns, {
    noWrap: true,
    space: "5",
    children: [/*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      display: "flex",
      flexDirection: "row",
      children: /*#__PURE__*/_jsx(Picture, {
        aspectRatio: 5.1,
        height: 24,
        backgroundColor: "transparent",
        src: `${CDN}/images/logos/autoguru.svg`,
        altText: "AutoGuru logo"
      })
    }), _Column || (_Column = /*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      display: "flex",
      flexDirection: "row",
      children: /*#__PURE__*/_jsx(SupportHeader, {})
    })), _Column2 || (_Column2 = /*#__PURE__*/_jsx(Column, {
      grow: true,
      alignSelf: "centre",
      justifyContent: "center",
      children: /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(GlobalSearch, {}), /*#__PURE__*/_jsx(GlobalNotification, {})]
      })
    })), _Column3 || (_Column3 = /*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      children: /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(SupplierRequiredBoundary, {
          noSelect: true,
          children: /*#__PURE__*/_jsx(GlobalSupplierSelect, {})
        })
      })
    }))]
  })
});